import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/components/AuthProvider";

const BillingContext = createContext({ billing: null, loading: true, refresh: () => {} });

export function BillingProvider({ children }) {
  const { user } = useAuth();
  const [billing, setBilling] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!user) { setBilling(null); setLoading(false); return; }
    try {
      const { data } = await api.get("/billing/me");
      setBilling(data);
    } catch {
      setBilling(null);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <BillingContext.Provider value={{ billing, loading, refresh }}>
      {children}
    </BillingContext.Provider>
  );
}

export const useBilling = () => useContext(BillingContext);
